"use strict";

var formatters = require('./common-formatters');
/**
 * get the value stored in the object following the dot notation
 * ie. getValue('a.b', {a: {b: 1}}) === 1
 *
 * @param  {String} key     location of the value using dot notation
 * @param  {Object} data   object to look
 * @return {Object}         content of data in the key position
 */
function getValue(key, data) {
  var val = data[key];
  if (!val && key.indexOf('.') > 0) {
    var keys = key.split('.');
    val = data;
    Object.keys(keys).forEach(function (i) {
      if (keys[i]) {
        // if data is undefined then don't try to keep going
        val = val && val[keys[i]];
      }
    });
  }
  return val;
}
/**
 * validate the data based on the provided schema
 * @param  {Object} data
 * @param  {Object} schema each entry has to be a formatter function
 * @return {Object} formatted data
 */
function runFormattersOfType(data, schema, formatterType) {
  var formatter;
  var value;
  var tempData = data;
  Object.keys(schema).forEach(function (key) {
    formatter = schema[key] ? schema[key][formatterType] : null;
    if (formatter) {
      value = getValue(key, data);
      if (value) {
        tempData[key] = formatter(value, key, data);
      }
    }
  });
  return tempData;
}

/**
 * validate the data based on the provided schema
 * @param  {Object} data
 * @param  {Object} schema each entry has to be a formatter function
 * @return {Object} formatted data
 */
function format(data, schema) {
  return runFormattersOfType(data, schema, 'formatter');
}

/**
 * validate the data based on the provided schema
 * @param  {Object} data
 * @param  {Object} schema each entry has to be a formatter function
 * @return {Object} formatted data
 */
function unformat(data, schema) {
  return runFormattersOfType(data, schema, 'unformatter');
}
module.exports = {
  format: format,
  unformat: unformat,
  formatters: formatters
};
